import React from "react";
import { CheckCircle, Cancel, ReportProblem } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

import { useStyles } from "./StatusIndicator.styles";

const StatusIndicator = (props) => {
  const classes = useStyles();
  const { t } = useTranslation(["common"]);

  const config = {
    inactive: {
      wrapperClass: classes.inactive,
      icon: (
        <div className={`${classes.activeIcon} ${classes.inActiveIcon}`}></div>
      ),
      label: t("common:indicator.label.inactive"),
    },
    active: {
      wrapperClass: classes.active,
      icon: <div className={classes.activeIcon}></div>,
      label: t("common:indicator.label.active"),
    },
    pending: {
      wrapperClass: classes.pending,
      icon: <ReportProblem className={classes.icon} />,
      label: t("common:indicator.label.pending"),
    },
    accepted: {
      wrapperClass: classes.active,
      icon: <CheckCircle className={classes.icon} />,
      label: t("common:indicator.label.accepted"),
    },
    rejected: {
      wrapperClass: classes.error,
      icon: <Cancel className={classes.icon} />,
      label: t("common:indicator.label.rejected"),
    },
    warning: {
      wrapperClass: classes.warning,
      icon: <ReportProblem className={classes.icon} />,
      label: t("common:indicator.label.rejected"),
    },
    success: {
      wrapperClass: classes.success,
      icon: <div className={classes.activeIcon}></div>,
      label: t("common:indicator.label.provisioning-status"),
    },
    failed: {
      wrapperClass: classes.failed,
      icon: (
        <div className={`${classes.activeIcon} ${classes.inActiveIcon}`}></div>
      ),
      label: t("common:indicator.label.provisioning-status"),
    },
    yes: {
      wrapperClass: classes.yes,
      icon: <div className={classes.activeIcon}></div>,
      label: t("common:indicator.label.added-to-master-DB"),
    },
    no: {
      wrapperClass: classes.no,
      icon: (
        <div className={`${classes.activeIcon} ${classes.inActiveIcon}`}></div>
      ),
      label: t("common:indicator.label.added-to-master-DB"),
    },
    low: {
      wrapperClass: classes.low,
      icon: <CheckCircle className={classes.icon} />,
    },
    med: {
      wrapperClass: classes.med,
      icon: <ReportProblem className={classes.icon} />,
    },
    high: {
      wrapperClass: classes.high,
      icon: <Cancel className={classes.icon} />,
    },
  };

  let type;

  switch (props.type) {
    case "inactive":
      type = config.inactive;
      break;
    case "active":
      type = config.active;
      break;
    case "pending":
      type = config.pending;
      break;
    case "accepted":
      type = config.accepted;
      break;
    case "rejected":
      type = config.rejected;
      break;
    case "warning":
      type = config.warning;
      break;
    case "success":
      type = config.success;
      break;
    case "failed":
      type = config.failed;
      break;
    case "yes":
      type = config.yes;
      break;
    case "no":
      type = config.no;
      break;
    case "low":
      type = config.low;
      break;
    case "med":
      type = config.med;
      break;
    case "high":
      type = config.high;
      break;
  }

  return (
    <>
      <div className={`${classes.indicator} ${type.wrapperClass}`}>
        {type.icon}
        <span className={classes.label}>{props.label ?? type.label}</span>
      </div>
      {props.helperText && (
        <span className={`${classes.helperText} ${type.wrapperClass}`}>
          {props.helperText}
        </span>
      )}
    </>
  );
};

StatusIndicator.defaultProps = {
  type: "active",
};

StatusIndicator.propTypes = {
  label: PropTypes.string,
  helperText: PropTypes.string,
  type: PropTypes.string,
};

export { StatusIndicator };
